import { useEffect, useState } from "react";
import axios from "axios";

export default function AboutQuiz2() {
  const [data, setData] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get("https://web1024.docmaster.in:5007/api/school/syllabus/published-about-quiz");
      const dataa = response?.data;
      setData(dataa?.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div style={{ color: "black", padding: "10px" }}>
      {/* {JSON.stringify(data)} */}

      {Array.isArray(data) &&
        [...data] // copy to avoid mutating state
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((item, index) => (
            <div key={index}>
              <h2 style={{ textAlign: "left", fontSize: "16px" }}>
                <strong>{item.heading}</strong>
              </h2>

              <div
                className="topic-description"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              />
            </div>
          ))}
    </div>
  );
}
